import { createFileRoute } from "@tanstack/react-router";
import { TransactionHistory } from "@/pages/3d/visualization/TransactionHistory";

export const Route = createFileRoute(
  "/demo/3d/visualization/transaction-history",
)({
  component: TransactionHistory,
});
